import { thimClick } from './utils.js';

export default function ModalPopup() {
	thimClick( '.thim-ekits-search-form__toggle', '.search-form-hoverbutton', '.ekits-modal__container' );

	/* Opening modal window function */
	function openModal() {
		/* Get trigger element */
		var modalButton = document.getElementsByClassName( 'modalbutton' );
		var inputSearch = document.getElementsByClassName( 'thim-ekits-search' );

		/* Set onclick event handler for all trigger elements */
		for (var i = 0; i < modalButton.length; i++) {
			modalButton[i].onclick = function( e ) {
				e.preventDefault();
				var target = this.getAttribute( 'href' ).substr( 1 );
				var modalWindow = document.getElementById( target );

				setTimeout( () => {
					if ( inputSearch.length > 0 ) {					
					inputSearch[0].focus(); 
				}}, 300 )

				modalWindow.classList ? modalWindow.classList.add( 'open' ) : modalWindow.className += ' ' + 'open';
			};
		}
	}

	function stopModal() {
		var videos = document.querySelectorAll('iframe, video');
		Array.prototype.forEach.call(videos, function (video) {
			if (video.tagName.toLowerCase() === 'video') {
				video.pause();
			} else {
				var src = video.src;
				video.src = src;
			}
		});
	}

	function closeModal() {
		/* Get close button */
		var closeButton = document.getElementsByClassName( 'ModalClose' );
		var closeOverlay = document.getElementsByClassName( 'ModalOverlay' );

		/* Set onclick event handler for close buttons */
		for (var i = 0; i < closeButton.length; i++) {
			closeButton[i].onclick = function() {
				var modalWindow = this.parentNode.parentNode;

				modalWindow.classList ? modalWindow.classList.remove( 'open' ) : modalWindow.className = modalWindow.className.replace( new RegExp( '(^|\\b)' + 'open'.split( ' ' ).join( '|' ) + '(\\b|$)', 'gi' ), ' ' );
				stopModal();
			};
		}

		/* Set onclick event handler for modal overlay */
		for (var i = 0; i < closeOverlay.length; i++) {
			closeOverlay[i].onclick = function() {
				var modalWindow = this.parentNode;

				modalWindow.classList ? modalWindow.classList.remove( 'open' ) : modalWindow.className = modalWindow.className.replace( new RegExp( '(^|\\b)' + 'open'.split( ' ' ).join( '|' ) + '(\\b|$)', 'gi' ), ' ' );
				stopModal();
			};
		}
	}

	/* Handling domready event IE9+ */
	function ready( fn ) {
		if (document.readyState != 'loading') {
			fn();
		} else {
			document.addEventListener( 'DOMContentLoaded', fn );
		}
	}

	/* Triggering modal window function after dom ready */
	ready( openModal );
	ready( closeModal );
}

